import React from 'react';
import { useSelector } from 'react-redux';
import ApplicationsAdminRoutes from '../components/applicationRoutes/AdminRoutes'
export default function AdminRoutes(props) {
  const {config} = useSelector((state) => state.config);
  return config.maintenance ? (
    <div className='maintenance'>
      <h1>Sorry for the inconvenience. We’ll be back soon!</h1>
    </div>
  ) : (
    <ApplicationsAdminRoutes {...props} />
  );
}